import { PERSONA_ORDER, type PersonaId } from './personas';

const VISIT_KEY = (id: PersonaId) => `wsky:visits:${id}`;
const ACHIEVEMENT_KEY = 'wsky:achievement:full';

export interface VisitState {
  count: number;
  firstAt: number;
  lastAt: number;
}

export function loadVisit(personaId: PersonaId): VisitState {
  try {
    const raw = localStorage.getItem(VISIT_KEY(personaId));
    if (!raw) return { count: 0, firstAt: 0, lastAt: 0 };
    const parsed = JSON.parse(raw) as VisitState;
    return {
      count: typeof parsed.count === 'number' ? parsed.count : 0,
      firstAt: typeof parsed.firstAt === 'number' ? parsed.firstAt : 0,
      lastAt: typeof parsed.lastAt === 'number' ? parsed.lastAt : 0
    };
  } catch {
    return { count: 0, firstAt: 0, lastAt: 0 };
  }
}

export function recordVisit(personaId: PersonaId): { isFirst: boolean; state: VisitState } {
  const prev = loadVisit(personaId);
  const now = Date.now();
  const next: VisitState = {
    count: prev.count + 1,
    firstAt: prev.firstAt || now,
    lastAt: now
  };
  try { localStorage.setItem(VISIT_KEY(personaId), JSON.stringify(next)); } catch { /* private mode */ }
  return { isFirst: prev.count === 0, state: next };
}

export function isVisited(personaId: PersonaId): boolean {
  return loadVisit(personaId).count > 0;
}

export function visitedSet(): Set<PersonaId> {
  const set = new Set<PersonaId>();
  for (const id of PERSONA_ORDER) {
    if (isVisited(id)) set.add(id);
  }
  return set;
}

export function isFullCollectionUnlocked(): boolean {
  return visitedSet().size === PERSONA_ORDER.length;
}

export function isAchievementShown(): boolean {
  try { return localStorage.getItem(ACHIEVEMENT_KEY) === '1'; } catch { return false; }
}

export function markAchievementShown(): void {
  try { localStorage.setItem(ACHIEVEMENT_KEY, '1'); } catch { /* private mode */ }
}
